import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ss-inline-panel',
  templateUrl: './inline-panel.component.html',
  styleUrls: ['./inline-panel.component.scss'],
  standalone: false
})
export class InlinePanelComponent implements OnChanges {
  @Input() open = false;
  @Input() title = '';
  @Input() icon = '';
  @Input() closeOnEscape = true;
  @Output() closed = new EventEmitter<void>();

  constructor(private elementRef: ElementRef<HTMLElement>) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open'] && this.open) {
      setTimeout(() => {
        const host = this.elementRef.nativeElement;
        host.querySelector<HTMLElement>('input:not([type=hidden]), select, textarea, ng-select input')?.focus();
        host.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }
  }

  @HostListener('keydown.escape', ['$event'])
  onEscape(event: Event): void {
    if (this.open && this.closeOnEscape) {
      event.stopPropagation();
      this.closed.emit();
    }
  }
}
